import React, {useState} from 'react';
import {Tooltip} from 'reactstrap';

const TooltipTitle = ({
    text,
    titleClassName,
    id,
    tooltipTitle
}) => {
    const [open,setOpen] = useState(false);
    const handleToggleTooltip = () => {
        setOpen(!open);
    };
    return(
        <React.Fragment>
            <span id={`tooltip_${id}`} className={`${titleClassName}`}>{text}</span>
            <Tooltip
                placement="right" isOpen={open} target={`tooltip_${id}`} toggle={handleToggleTooltip}
            >
                {tooltipTitle}
            </Tooltip>
        </React.Fragment>
    );
};

export default TooltipTitle;